<template>
<div class="bto-sb-accordion-header" 
  :class="[bet.isOpen ? 'bto-sb-accordion-header-show':'bto-sb-accordion-collapsed']" 
  @click="$emit('loadDetails', bet)">
  <span>
    <i>{{t('BetSlip.No.')}}</i>
    <i>{{bet.betSlipGroupID}}</i>
  </span>
  <span>
    <i>{{t('Mobile.Type')}}</i>
    <i>{{t(bet.matchesType || '')}}</i>
  </span>
  <span v-if="!hideUserName" class="bto-sb-mybets-player">
    <i>{{t('BetSlip.Player')}}</i>
    <i>{{bet.username}}</i>
  </span>
  <span>
    <i>{{t('Mobile.Date')}}</i>
    <i>{{bet.createdOn}}</i>
  </span>
  <span>
    <i>{{t('Mobile.Stake')}}</i>
    <i>{{bet.stake|formatAmountDisplay(bet.currencyCode)}}</i>
  </span>
  <span>
    <i>{{t('Mobile.Winnings')}}</i>
    <i>{{bet.winnings|formatAmountDisplay(bet.currencyCode)}}</i>
  </span>
  <span :class="{'bto-sb-mybet-cashout': getCashout > 0}">
    <i>{{t('Mobile.Status')}}</i>
    <i :class="generateStatusClass">{{t(bet.betSlipGroupStatus||'')}}</i>
    <i v-if="getCashout > 0" class="bto-app-cash"></i>
  </span>
</div>
</template>
<script>
  import Base from './base';
  import { BETSLIP_STATUS } from 'bto-models/betslip';

  export default {
    name: 'MybetHeaderWeb',
    extends: Base,
    data() {
      return {
        hideUserName: APP_SETTINGS.myBets.hideUserName,
      };
    },
    computed: {
      generateStatusClass() {
        if (this.checkStatus(BETSLIP_STATUS.PLACED)) {
          return ['bto-sb-mybets-placed'];
        } else if (this.checkStatus(BETSLIP_STATUS.WON)) {
          return ['bto-sb-mybets-won'];
        } else if (this.checkStatus(BETSLIP_STATUS.LOST)) {
          return ['bto-sb-mybets-lost'];
        } else if (this.checkStatus(BETSLIP_STATUS.CANCELLED)) {
          return ['bto-sb-mybets-cancelled'];
        } else if (this.checkStatus(BETSLIP_STATUS.REJECTED)) {
          return ['bto-sb-mybets-rejected'];
        } else if (this.checkStatus(BETSLIP_STATUS.CACHEDOUT)) {
          return ['bto-sb-mybets-cashout-up'];
        } else if (this.checkStatus(BETSLIP_STATUS.PAID)) {
          return ['bto-sb-mybets-paid'];
        } else if (this.checkStatus(BETSLIP_STATUS.PENDING)) {
          return ['bto-sb-mybets-pending'];
        } else if (this.checkStatus(BETSLIP_STATUS.VOID)) {
          return ['bto-sb-mybets-void'];
        }
        return null;
      },
    },
  };
</script>
